import $ from 'jquery';
import format from 'number-format.js';
import {plusBasketItem, minusBasketItem, removeBasketItem, addFavorite} from '../api/api';
import TweenLite from 'TweenLite';
import Power2 from 'TweenLite';
import amountForm, {updatePrice} from '../amount/amount';
import Counter from '../counter/counter';

export default class Basket {
	constructor(options) {
		const defaults = {
			el: '.js-basket',
			dom: {
				heading: '.js-basket-heading',
				item: '.js-basket-item',
				table: '.js-basket-table',
				availability: '.js-basket-availability',
				price: '.js-item-price',
				counter: '.js-counter-input',
				total: '.js-item-total',
				presentbox: '.js-present-box',
				overall: '.js-overall-cost',
				giftcard: '.js-gift-card-balance',
				amount: '.js-overall-amount',
				cardShow: '.js-promo-card-show',
				cardForm: '.js-promo-card-form',
				cardCheck: '.js-promo-card-check',
				cardInput: '.js-promo-card-input',
				cardButton: '.js-promo-card-button',
				codeShow: '.js-promo-code-show',
				codeForm: '.js-promo-code-form',
				codeCheck: '.js-promo-code-check',
				codeInput: '.js-promo-code-input',
				removeItem: '.js-remove-button',
				favoriteItem: '.js-favorite-button',
				codeButton: '.js-promo-code-button',
				plus: '.js-counter-plus',
				minus: '.js-counter-minus'
			},
			classes: {
				el: {
					state: {
						formed: 'basket_state_formed',
						empty: 'basket_state_empty',
						error: 'basket_state_error',
						done: 'basket_state_done'
					}

				},
				bonus: {
					state: {
						visible: 'amount__check_state_visible'
					}
				},
				inputWrap: {
					state: {
						error: 'field__input_state_error'
					}
				},
				form: {
					state: {
						visible: 'amount__promo-form_state_visible'
					}
				}
			},
			atributes: {
				removeAction: 'action-remove',
				favoriteAction: 'action-favorite'
			}
		};

		this.options = $.extend(true, {}, defaults, options);
		this.$el = $(this.options.el);
	}

	getDom() {
		this.$heading = this.$el.find(this.options.dom.heading);
		this.$item = this.$el.find(this.options.dom.item);
		this.$table = this.$el.find(this.options.dom.table);
		this.$availability = this.$el.find(this.options.dom.availability);
		this.$counter = this.$el.find(this.options.dom.counter);
		this.$price = this.$el.find(this.options.dom.price);
		this.$total = this.$el.find(this.options.dom.total);
		this.$presentbox = this.$el.find(this.options.dom.presentbox);
		this.$overall = this.$el.find(this.options.dom.overall);
		this.$giftcard = this.$el.find(this.options.dom.giftcard);
		this.$amount = this.$el.find(this.options.dom.amount);
		this.$cardShow = this.$el.find(this.options.dom.cardShow);
		this.$cardForm = this.$el.find(this.options.dom.cardForm);
		this.$cardCheck = this.$el.find(this.options.dom.cardCheck);
		this.$cardInput = this.$el.find(this.options.dom.cardInput);
		this.$cardButton = this.$el.find(this.options.dom.cardButton);
		this.$codeShow = this.$el.find(this.options.dom.codeShow);
		this.$codeForm = this.$el.find(this.options.dom.codeForm);
		this.$codeCheck = this.$el.find(this.options.dom.codeCheck);
		this.$codeInput = this.$el.find(this.options.dom.codeInput);
		this.$codeButton = this.$el.find(this.options.dom.codeButton);
		this.$removeItem = this.$el.find(this.options.dom.removeItem);
		this.$favoriteItem = this.$el.find(this.options.dom.favoriteItem);
		this.$plus = this.$el.find(this.options.dom.plus);
		this.$minus = this.$el.find(this.options.dom.minus);
	}

	setAvailability() {
		this.$table.each((i, table) => {
			const $table = $(table);
			const $items = $table.find(this.options.dom.item);
			const $availability = $table.find(this.options.dom.availability);

			if ($items.length) {
				$availability.text('(' + $items.length + ')');
			} else {
				$table.remove();
			}
		});
	}

	setBasketState() {
		if (!this.$item.length) {
			this.$el.removeClass(this.options.classes.el.state.formed);
			this.$el.addClass(this.options.classes.el.state.empty);
		}
	}

	getOptions() {
		this.actionRemove = this.$el.data(this.options.atributes.removeAction);
		this.favoriteAction = this.$el.data(this.options.atributes.favoriteAction);
	}

	getTotalCost = () => {
		const presentBoxCost = this.$presentbox.data('value');
		this.$item = this.$el.find(this.options.dom.item);
		let overall = 0;

		if (this.$presentbox.is(':checked')) {
			overall += presentBoxCost;
		}
		this.$item.each((i, item) => {
			const $item = $(item);
			const $price = Number($item.find(this.options.dom.price).data('value'));
			const $counter = Number($item.find(this.options.dom.counter).val());
			const $total = $item.find(this.options.dom.total);
			if ($price && $counter) {
				$total.text(format( '# ##0.##', ($price * $counter) + ' ₽'));
				overall += $price * $counter;
			}
		});

		updatePrice(overall);
	};

	removeItem(e) {
		const $target = $(e.target);
		this.getProId().then(item => this.fetchItem(item)).then(this.updateDomData);
		$target.trigger('getId');
		this.getTotalCost();
	}

	fetchItem(item) {
		return new Promise(resolve => {
			removeBasketItem(item.data('product-id')).then(() => resolve(item));
		});
	}

	onDeleteComplete = item => () => {
		item.remove();
		this.setAvailability();
		setTimeout(() => {
			this.setBasketState();
		}, 100);
	}

	updateDomData = item => {
		TweenLite.to(item, 0.4, {
			height: 0,
			opacity: 0,
			ease: Power2.easeOut,
			onComplete: this.onDeleteComplete(item)
		});
	};

	plusItem(e) {
		const $target = $(e.target);
		this.getProId().then(item => plusBasketItem(item.data('product-id')));
		$target.trigger('getId');
	}

	minusItem(e) {
		const $target = $(e.target);
		this.getProId().then(item => minusBasketItem(item.data('product-id')));
		$target.trigger('getId');
	}

	getProId() {
		return new Promise(( resolve, reject ) => {
			this.$item.on('getId', e => {
				const item = $(e.currentTarget);
				if (item.length) {
					resolve(item);
				} else {
					reject(new Error('atribute not found'));
				}
			});
		});
	}

	removeFromFavorit = e => {
		const $target = $(e.target);
		$target.html(`Отложить в избранное`);
		$target.removeClass('js-remove-from-favorite');
		$target.unbind('click', this.removeFromFavorit);
	};

	favoriteItem(e) {
		const $target = $(e.target);
		this.getProId().then( item => addFavorite(item.data('product-id')));
		$target.trigger('getId');

		$target.html(`Убрать из избранного`);
		$target.addClass('js-remove-from-favorite');
		$target.on('click', this.removeFromFavorit);
	}

	render() {
		if (this.$el.length) {
			this.getDom();
			this.getOptions();
			this.setAvailability();
			const counter = new Counter(null, this.getTotalCost);
			counter.render();
			this.$removeItem.on('click', e => { this.removeItem(e); });
			this.$favoriteItem.on('click', e => { this.favoriteItem(e); });
			this.$plus.on('click', e => this.plusItem(e));

			this.$minus.on('click', e => this.minusItem(e));
			this.getTotalCost();
			amountForm();
		}


		return this;
	}
}



/** WEBPACK FOOTER **
 ** ./app/blocks/basket/basket.js
 **/